/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import config from "config";
import { Route, BrowserRouter as Router, Switch } from "react-router-dom";
import AppUniversal from "./admin/app-universal";
import { Provider } from "react-redux";
import { ThemeProvider } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import store from "../src/redux/store";
import ClarityUserSync from "./components/ClarityUserSync";

// AppContainer component
const AppContainer = function (props) {
  if (props) {
    const url = props.location.pathname.split("/")[1];

    useEffect(() => {
      const handleMouseMove = (event) => {
        const cursorInner = document.querySelector(".cursor-inner");
        const cursorOuter = document.querySelector(".cursor-outer");

        if (cursorOuter) {
          cursorOuter.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
        }

        if (cursorInner) {
          cursorInner.style.transform = `translate(${event.clientX}px, ${event.clientY}px)`;
        }
      };

      const handleMouseEnter = () => {
        const cursorInner = document.querySelector(".cursor-inner");
        const cursorOuter = document.querySelector(".cursor-outer");

        if (cursorInner) {
          cursorInner.classList.add("s");
        }

        if (cursorOuter) {
          cursorOuter.classList.add("s");
        }
      };

      const handleMouseLeave = (event) => {
        const cursorInner = document.querySelector(".cursor-inner");
        const cursorOuter = document.querySelector(".cursor-outer");

        if (
          event.target.tagName !== "A" ||
          !event.target.closest(".cursor-pointer")
        ) {
          if (cursorInner) {
            cursorInner.classList.remove("cursor-hover");
          }

          if (cursorOuter) {
            cursorOuter.classList.remove("cursor-hover");
          }
        }
      };

      document.body.addEventListener("mousemove", handleMouseMove);
      document.body.addEventListener("mouseenter", handleMouseEnter);
      document.body.addEventListener("mouseleave", handleMouseLeave);

      const cursorInner = document.querySelector(".cursor-inner");
      const cursorOuter = document.querySelector(".cursor-outer");

      if (cursorInner) {
        cursorInner.style.visibility = "visible";
      }

      if (cursorOuter) {
        cursorOuter.style.visibility = "visible";
      }

      return () => {
        document.body.removeEventListener("mousemove", handleMouseMove);
        document.body.removeEventListener("mouseenter", handleMouseEnter);
        document.body.removeEventListener("mouseleave", handleMouseLeave);
      };
    }, []);

    return (
      <Provider store={store}>
        <ClarityUserSync />
        <ThemeProvider
          breakpoints={["xl", "lg", "md", "sm"]}
          minBreakpoint="sm"
        >
          <ToastContainer />
          <Router basename={`${config.publicPath}`}>
            {" "}
            {url === "admin" ? (
              <div>
                <Switch>
                  <Route path="/admin" component={AppUniversal} />
                </Switch>
              </div>
            ) : (
              <Switch>
                <Route path="/" exact component={AppUniversal} />
              </Switch>
            )}
          </Router>
        </ThemeProvider>
      </Provider>
    );
  }
  return null;
};

export default AppContainer;
